import React from 'react';
import { Badge } from '@mantine/core';
import { useAppSelector } from '@/hooks/reduxHooks';

type BadgeProps = {
  description: string;
  icon: React.ReactNode;
  variant?: string;
  size?: string;
};

export const ComingSoon = ({
  description,
  icon,
  variant = 'filled',
  size = 'lg',
}: BadgeProps) => {
  const theme = useAppSelector((state) => state.theme.theme);
  return (
    <Badge
      size={size}
      variant={variant}
      color={theme === 'light' ? '#798188' : '#a6afb850'}
      leftSection={icon}
      className="mb-4 mr-4"
      style={{ fontWeight: '400', alignContent: 'center' }}
    >
      {description}
    </Badge>
  );
};
